import ProjectImg from "../../assets/project-planning-header@2x.png";
import Ecom from "../../assets/ecom.png";
import Port from "../../assets/portlofi.png";

export const myProjects = [
  {
    image: Ecom,
    title: "E-commerce",
    git: "https://github.com/inferno332/Ecommerce_shop",
    demo: "https://ls-eshop.vercel.app/",
  },
  {
    image: ProjectImg,
    title: "Mini Quiz",
    git: "https://github.com/Kin2808/miniQuiz-client",
    git1: "https://github.com/Kin2808/miniQuiz-server",
  },
  {
    image: Port,
    title: "Portfolio & Blog",
    git: "https://github.com/Kin2808/My-Portfolio",
    demo: "https://kin-one.vercel.app/",
  },
];
